import { QueryClient } from "react-query";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Don't retry client errors (4xx) - they won't succeed on retry and just
      // multiply request telemetry. Keep the default 3 retries for other failures.
      retry: (failureCount, error: any) => {
        const status = error?.response?.status ?? error?.status;
        if (status >= 400 && status < 500) return false;
        return failureCount < 3;
      },
    },
  },
});

const reactQueryUtils = {
  client,
};

export default reactQueryUtils;
